module.exports = __webpack_public_path__ + "static/media/bg-arlet-visibilite.56dc8c38.jpg";